/**
 * The 4-rect pixel triangle — the shared glyph behind `Pixel Button`'s ` ▸`
 * arrow and both `Vote Buttons` marks (DC-RUNTIME §6.3 / §6.6).
 *
 * `design/DESIGN-CLAUDE.md` "Optical centering": icons inside pixel-font CTAs
 * use this SVG, never a font glyph. Apex points UP at `rotate={0}`; the callers
 * rotate it (90° = right, 180° = down).
 *
 * The rect geometry is verbatim from both `.dc.html` sources — widths 1/3/5/7
 * at y 0/2/4/6 inside a `0 0 9 8` viewBox, `fill="currentColor"`. `width`/
 * `height` are deliberately independent (Vote Buttons renders 11×10, a slight
 * non-uniform stretch that is part of the frozen look).
 */

import type { CSSProperties } from 'react';

export interface PixelTriangleProps {
  /** rendered px width */
  w: number | string;
  /** rendered px height */
  h: number | string;
  /** degrees; omitted / 0 emits no `transform` at all (matches Vote Buttons YES) */
  rotate?: number;
  /** merged after the base `display:block;flex:none` */
  style?: CSSProperties;
}

export function PixelTriangle({ w, h, rotate, style }: PixelTriangleProps) {
  const base: CSSProperties = { display: 'block', flex: 'none' };
  if (rotate) base.transform = 'rotate(' + rotate + 'deg)';
  return (
    <svg width={w} height={h} viewBox="0 0 9 8" style={{ ...base, ...style }} aria-hidden="true">
      <rect x="4" y="0" width="1" height="2" fill="currentColor" />
      <rect x="3" y="2" width="3" height="2" fill="currentColor" />
      <rect x="2" y="4" width="5" height="2" fill="currentColor" />
      <rect x="1" y="6" width="7" height="2" fill="currentColor" />
    </svg>
  );
}
